
import { Component, Prop, Vue } from 'vue-property-decorator'
import BasicModal from '~/components/common/modals/basic/Basic.vue'
import Close from '~/components/common/ctrls/CloseCrossCtrl.vue'
import ButtonFS from '~/components/common/buttons/ButtonFS.vue'
import Button from '~/components/common/buttons/DashboardButton.vue'
import { manageWidgets } from '~/lib/utils/utils'

const features = [
  {
    title: 'Scholarship credibility scores',
    text: 'Focus your time and energy on highly rated scholarships.'
  },
  {
    title: 'Track application status',
    text: 'Monitor your applications in real-time.'
  },
  {
    title: 'Customized recommendations',
    text: 'Apply for scholarships recommended for your profile and interests.'
  },
  {
    title: 'Number of applicants',
    text: 'Boost your chances by applying to scholarships with fewer applicants.'
  },
  {
    title: 'Automatically reapply',
    text: 'Be automatically reapplied for scholarships with year-round winners.'
  }, {
    title: 'Similar scholarships',
    text: 'Repurpose your essays to apply for similar scholarships, AI-generated based on your previous applications.'
  }
]

@Component({
  components: {
    BasicModal,
    ButtonFS,
    Button,
    Close
  }
})
export default class FreemiumModal extends Vue {
  @Prop({
    type: Array,
    default: () => ([])
  }) title

  @Prop({
    type: String,
    default: ''
  }) referrer: string

  @Prop({
    type: String,
    default: ''
  }) mixpanelEvent: string // open from

  @Prop({
    type: Boolean,
    default: false
  }) isMob!: boolean

  private manageWidgets = manageWidgets

  freemiumContent = {
    title: [],
    subTitle: 'Access our full suite of strategy tools - take the next step and unlock Pro.',
    features,
    leftButton: {
      text: 'Upgrade to Pro plan',
      icon: 'padlock-open'
    },
    rightButton: {
      text: 'Nah, I\'ll risk it'
    },
    bottomText: 'All your data will be saved regardless of plan.'
  }

  get leftButtonText() {
    return this.isMob
      ? this.freemiumContent.leftButton.text.substring(0, 7)
      : this.freemiumContent.leftButton.text
  }

  mixpanelTrack(event) {
    if (this.$route.params.cardId) {
      const props = this.$mixpanel.fillProps(event, { scholarshipId: Number(this.$route.params.cardId) })
      if (this.mixpanelEvent) {
        props[`${this.$mixpanel.props.OPENED_FROM}`] = this.mixpanelEvent
      }
      this.$mixpanel.track(event, props)
    } else {
      const props = this.$mixpanel.fillProps(event)
      if (this.mixpanelEvent) {
        props[this.$mixpanel.props.OPENED_FROM] = this.mixpanelEvent
      }
      this.$mixpanel.track(event, props)
    }
  }

  created() {
    this.mixpanelTrack(this.$mixpanel.events.UPGRADE_PRO_MODAL_VIEW)
  }

  mounted() {
    if (this.isMob) {
      this.manageWidgets(true)
    }
  }

  beforeDestroy() {
    if (this.isMob) {
      this.manageWidgets(false)
    }
  }

  close() {
    this.mixpanelTrack(this.$mixpanel.events.PRO_CHANCES_CLICK)
    this.$emit('close')
  }

  showPaymentModal() {
    this.mixpanelTrack(this.$mixpanel.events.UPGRADE_PRO_PLAN_CLICK)
    this.$emit('close')

    window.ppsdk?.open()
  }
}
